var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customer-analytics" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "card" }, [
        _vm._m(0),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { attrs: { for: "startDate" } }, [
                _vm._v("Start Date:"),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.startDate,
                    expression: "startDate",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "date", id: "startDate" },
                domProps: { value: _vm.startDate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.startDate = $event.target.value
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "col-md-6" }, [
              _c("label", { attrs: { for: "endDate" } }, [_vm._v("End Date:")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.endDate,
                    expression: "endDate",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "date", id: "endDate" },
                domProps: { value: _vm.endDate },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.endDate = $event.target.value
                  },
                },
              }),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.metrics, function (metric, index) {
              return _c("div", { key: index, staticClass: "col-md-4 mb-3" }, [
                _c("div", { staticClass: "card h-100" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(metric.title)),
                    ]),
                    _c("p", { staticClass: "card-text" }, [
                      _vm._v(_vm._s(metric.value)),
                    ]),
                  ]),
                ]),
              ])
            }),
            0
          ),
          _c("div", { staticClass: "alert alert-info mt-3" }, [
            _vm._v(
              " Data is static. In a production system, these metrics would be dynamically fetched. "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h3", [_vm._v("Enhanced Customer Analytics")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }